import React, { useState } from 'react'
import { Input, FormCustom } from '../../Components/Form/Form'

const TypePriceForm = ({ data, onSubmit, disablebSubmit, loadSubmit }) => {
    const [row, setRow] = useState({
        p_id_type_price: data.id_type_price,
        p_name_price: data.name_price
    })

    return <FormCustom dataSubmit={row} onSubmit={onSubmit} disablebSubmit={disablebSubmit} loadSubmit={loadSubmit}>
        <Input
            text="Descripción"
            placeholder="Descripción"
            classNameParent="col-12 mb-2"
            icon="far fa-comment-alt"
            required
            invalid="El campo es obligatorio."
            defaultValue={data.name_price}
            onChange={e => setRow({ ...row, p_name_price: e.currentTarget.value })}
            maxLength={150}
        />
    </FormCustom>
}

TypePriceForm.defaultProps = {
    data: {
        id_type_price: '',
        name_price: ''
    },
    onSubmit: () => {},
    loadSubmit: false
}

export default TypePriceForm;